/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacySaleCredit from './pharmacy-sale-credit';
import PharmacySaleCreditDetail from './pharmacy-sale-credit-detail';
import PharmacySaleCreditUpdate from './pharmacy-sale-credit-update';
import PharmacySaleCreditDeleteDialog from './pharmacy-sale-credit-delete-dialog';

const PharmacySaleCreditRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacySaleCredit />} />
    <Route path="new" element={<PharmacySaleCreditUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacySaleCreditDetail />} />
      <Route path="edit" element={<PharmacySaleCreditUpdate />} />
      <Route path="delete" element={<PharmacySaleCreditDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacySaleCreditRoutes;
